/**
 * API Endpoints - 중앙 집중식 엔드포인트 관리
 *
 * 모든 API 경로를 한 곳에서 관리하여 유지보수성 향상
 *
 * @example
 * import { ENDPOINTS } from '@new/api/endpoints'
 *
 * const response = await apiClient.get(ENDPOINTS.USER.PROFILE)
 */

const API_VERSION = '/v1';

export const ENDPOINTS = {
  // 인증 관련
  AUTH: {
    LOGIN: `${API_VERSION}/auth/login`,
    LOGOUT: `${API_VERSION}/auth/logout`,
    REFRESH: `${API_VERSION}/auth/refresh`,
    ME: `${API_VERSION}/auth/me`,
  },

  // 사용자 관련
  USER: {
    PROFILE: `${API_VERSION}/user/profile`,
    UPDATE: `${API_VERSION}/user/update`,
    PASSWORD: `${API_VERSION}/user/password`,
  },

  // 회사 관련
  COMPANY: {
    INFO: (companyId: string | number): string => `${API_VERSION}/company/${companyId}`,
    LIST: `${API_VERSION}/company`,
    CREATE: `${API_VERSION}/company`,
    UPDATE: (companyId: string | number): string => `${API_VERSION}/company/${companyId}`,
  },

  // 캠페인 관련
  CAMPAIGN: {
    LIST: `${API_VERSION}/campaign`,
    DETAIL: (campaignId: string | number): string => `${API_VERSION}/campaign/${campaignId}`,
    CREATE: `${API_VERSION}/campaign`,
    UPDATE: (campaignId: string | number): string => `${API_VERSION}/campaign/${campaignId}`,
    DELETE: (campaignId: string | number): string => `${API_VERSION}/campaign/${campaignId}`,
    STATS: (campaignId: string | number): string => `${API_VERSION}/campaign/${campaignId}/stats`,
  },

  // 광고 관련
  AD: {
    LIST: `${API_VERSION}/ad`,
    DETAIL: (adId: string | number): string => `${API_VERSION}/ad/${adId}`,
    CREATE: `${API_VERSION}/ad`,
    UPDATE: (adId: string | number): string => `${API_VERSION}/ad/${adId}`,
    STATUS: (adId: string | number): string => `${API_VERSION}/ad/${adId}/status`,
  },

  // 리포트 관련
  REPORT: {
    SUMMARY: `${API_VERSION}/report/summary`,
    DETAIL: (reportId: string | number): string => `${API_VERSION}/report/${reportId}`,
    EXPORT: `${API_VERSION}/report/export`,
  },

  // 결제 관련
  PAYMENT: {
    CARDS: `${API_VERSION}/payment/cards`,
    ADD_CARD: `${API_VERSION}/payment/cards`,
    DELETE_CARD: (cardId: string | number): string => `${API_VERSION}/payment/cards/${cardId}`,
    HISTORY: `${API_VERSION}/payment/history`,
    SUBSCRIBE: `${API_VERSION}/payment/subscribe`,
  },
} as const;

export default ENDPOINTS;
